import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    GET_USERS: (
        pageNumber,
        pageSizeCount,
        searchValue
    ) => ({
        url: `users-list?page=${pageNumber}&pageSize=${pageSizeCount}&search=${searchValue}`,
        method: "get",
    }),

    UPDATE_ROLE: {
        url: "user-role/save",
        method: "post",
    },

    DELETE_ROLE: {
        url: "user/delete",
        method: "post",
    },
    ADMINS_LIST: {
        url: "admins-lists",
        method: "post",
    },


};

export const useUsers = (
    pageNumber,
    pageSizeCount,
    searchValue
) =>
    useApiFetcherSWR(
        API_ENDPOINT.GET_USERS(
            pageNumber,
            pageSizeCount,
            searchValue
        )
    );

export const useUpdateRole = () =>
    useApiFetcherSWR(API_ENDPOINT.UPDATE_ROLE);

export const useDeleteRole = () =>
    useApiFetcherSWR(API_ENDPOINT.DELETE_ROLE);

export const useAdminsList = () => {
    return useApiFetcherSWR(API_ENDPOINT.ADMINS_LIST);
};
